export default __webpack_public_path__ + "static/media/contactRightImage.a12f8d36.png";